// Modules
import styled from "styled-components"

// Constants
import grid from "~constants/grid"
import colors from "~constants/colors"

const Title = styled.h1`
  color: ${colors.gray3};
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 42px;

  @media (max-width: ${grid.small}) {
    font-size: 28px;
  }
`

export default Title
